<template>
  <div class="step-body step-identity">
    <PhotoUploader :photo="data.photo" @update:photo="setPhoto" />

    <div class="form-grid">
      <LtField label="שם אומן / להקה" hint="זה השם שיופיע על הקליפים והאלבומים שלכם" :error="errors.artistName">
        <div class="input-wrap">
          <LtIcon name="user" :size="18" />
          <input type="text" :value="data.artistName" @input="set({ artistName: $event.target.value })" placeholder="לדוגמה: עומר אדם" autocomplete="off" />
        </div>
      </LtField>

      <LtField label="כתובת מייל" hint="כאן נשלח קישור לאישור החשבון" :error="errors.email">
        <div class="input-wrap">
          <LtIcon name="mail" :size="18" />
          <input type="email" :value="data.email" @input="set({ email: $event.target.value })" placeholder="artist@example.com" dir="ltr" autocomplete="email" />
        </div>
      </LtField>

      <LtField label="מספר פלאפון" hint="ליצירת קשר ועדכונים חשובים" :error="errors.phone">
        <div class="input-wrap">
          <LtIcon name="phone" :size="18" />
          <input type="tel" :value="data.phone" @input="set({ phone: $event.target.value })" placeholder="050-0000000" dir="ltr" autocomplete="tel" />
        </div>
      </LtField>

      <LtField label="סיסמה" hint="לפחות 8 תווים" :error="errors.password">
        <div class="input-wrap">
          <LtIcon name="lock" :size="18" />
          <input :type="showPw ? 'text' : 'password'" :value="data.password" @input="set({ password: $event.target.value })" placeholder="••••••••" autocomplete="new-password" />
          <button type="button" class="input-icon-btn" @click="showPw = !showPw" :aria-label="showPw ? 'הסתר סיסמה' : 'הצג סיסמה'">
            <LtIcon :name="showPw ? 'eye-off' : 'eye'" :size="18" />
          </button>
        </div>
        <div v-if="data.password" class="pw-strength">
          <div class="pw-bar">
            <span v-for="i in 4" :key="i" class="pw-seg" :class="i <= pwStrength ? 'on lvl-' + pwStrength : ''"></span>
          </div>
          <span class="pw-label">{{ pwLabel }}</span>
        </div>
      </LtField>
    </div>
  </div>
</template>

<script>
import LtIcon from './LtIcon.vue';
import LtField from './LtField.vue';
import PhotoUploader from './PhotoUploader.vue';

export default {
  name: 'StepIdentity',
  components: { LtIcon, LtField, PhotoUploader },
  props: {
    data:   { type: Object, required: true },
    errors: { type: Object, default: () => ({}) },
  },
  emits: ['update'],
  data() {
    return { showPw: false };
  },
  computed: {
    pwStrength() {
      const v = this.data.password || '';
      let s = 0;
      if (v.length >= 8) s++;
      if (/[A-Z]/.test(v) || /[א-ת]{4,}/.test(v)) s++;
      if (/[0-9]/.test(v)) s++;
      if (/[^A-Za-z0-9]/.test(v)) s++;
      return Math.min(s, 4);
    },
    pwLabel() {
      return ['', 'חלשה', 'סבירה', 'טובה', 'חזקה'][this.pwStrength];
    },
  },
  methods: {
    set(patch) { this.$emit('update', patch); },
    setPhoto(photo) { this.set({ photo }); },
  },
}
</script>
